import React, { useState } from 'react';
import { LoadingAnimation } from '../components/LoadingAnimation';
import '../styles/LoadingAnimationDemo.css';

export const LoadingAnimationDemo: React.FC = () => {
  const [size, setSize] = useState(120);
  const [message, setMessage] = useState('Building your LEGO directory...');
  const [showMessage, setShowMessage] = useState(true);

  return (
    <div className="demo-container">
      <h1>Loading Animation Demo</h1>

      <div className="demo-preview">
        <LoadingAnimation
          size={size}
          message={showMessage ? message : undefined}
        />
      </div>

      <div className="demo-controls">
        <div className="control-group">
          <label htmlFor="size-slider">
            Size: {size}px
          </label>
          <input
            id="size-slider"
            type="range"
            min="60"
            max="300"
            value={size}
            onChange={(e) => setSize(Number(e.target.value))}
          />
        </div>

        <div className="control-group">
          <label htmlFor="message-input">
            Message:
          </label>
          <input
            id="message-input"
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Enter loading message..."
            maxLength={100}
          />
        </div>

        <div className="control-group">
          <label>
            <input
              type="checkbox"
              checked={showMessage}
              onChange={(e) => setShowMessage(e.target.checked)}
            />
            Show message
          </label>
        </div>
      </div>

      <div className="demo-variants">
        <h2>Usage Examples</h2>

        <div className="variant-grid">
          <div className="variant-card">
            <h3>Small</h3>
            <LoadingAnimation size={60} />
          </div>

          <div className="variant-card">
            <h3>Medium (Default)</h3>
            <LoadingAnimation size={120} message="Loading..." />
          </div>

          <div className="variant-card">
            <h3>Large</h3>
            <LoadingAnimation size={180} message="Searching LEGO database..." />
          </div>
        </div>
      </div>

      <div className="demo-code">
        <h2>Usage</h2>
        <pre>
{`import { LoadingAnimation } from './components/LoadingAnimation';

// Basic usage
<LoadingAnimation />

// With custom size
<LoadingAnimation size={180} />

// With custom message
<LoadingAnimation
  size={120}
  message="Building your LEGO directory..."
/>

// Without message
<LoadingAnimation size={100} message={undefined} />`}
        </pre>
      </div>
    </div>
  );
};
